import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { valueExists } from '../../misc/utils'
import {
    createIdea,
    updateIdea,
    deleteIdea,
    getIdea,
    REDIRECT_TO_IDEA,
} from '../../store/actions/ideas'
import { store } from '../../store/store'
import AttachmentSection from '../common/attachment-section'
import { confirmationDialog } from '../common/confirmation-dialog'
import IconButtonLabel from '../common/icon-button-label'
import IconSelector from '../common/icon-selector'
import TagSelector from '../common/tag-selector'
import TextAreaCharCount from '../common/text-area-char-count'
import { showError } from '../../store/actions/alerts'

export class SubmitIdeaView extends React.Component {
    constructor(props) {
        super(props)

        // Default new idea
        var newIdea = {
            title: '',
            description: '',
            tags: [],
            icon: 'lightbulb',
            attachments: [],
        }

        this.state = {
            editExisting:
                valueExists(this.props.location, 'editExisting') &&
                this.props.location.editExisting,
            idea: newIdea,
        }
    }

    componentDidMount() {
        // Load idea from server if in edit mode
        if (this.state.editExisting && this.props.selectedIdeaId) {
            this.props.getIdea(this.props.selectedIdeaId)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.idea && prevProps.idea !== this.props.idea) {
            const idea = this.props.idea
            if (!idea.attachments) idea.attachments = []
            this.setState({ idea: this.props.idea })
        }

        if (this.props.justSubmitted) {
            store.dispatch({ type: REDIRECT_TO_IDEA })
            this.props.history.push({
                pathname: '/idea',
            })
        }
    }

    onTitleChange = (text) => {
        this.setState((prevState) => ({
            idea: { ...prevState.idea, title: text },
        }))
    }

    onDescriptionChange = (text) => {
        this.setState((prevState) => ({
            idea: { ...prevState.idea, description: text },
        }))
    }

    onIconSelect = (selection) => {
        this.setState((prevState) => ({
            idea: { ...prevState.idea, icon: selection },
        }))
    }

    onTagSelect = (selectedTags) => {
        if (selectedTags && selectedTags.length > 0) 
            this.setState((prevState) => ({
                idea: { ...prevState.idea, tags: selectedTags.map((t) => t.value) },
            }))
        else
        this.setState((prevState) => ({
            idea: { ...prevState.idea, tags: [] },
        }))
    }

    onSubmit = () => {
        const title = this.state.editExisting ? 'Edit Idea' : 'New Idea'

        if (this.state.idea.title.trim().length < 10) {
            store.dispatch(showError("That title is too short!"))
            return
        }

        if (this.state.idea.description.trim().length < 10) {
            store.dispatch(showError("That description is too short!"))
            return
        }


        confirmationDialog({
            title: title,
            text: 'Do you wish to submit the idea?',
            positiveText: 'Submit',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                // Submit idea
                if (this.state.editExisting) {
                    this.props.updateIdea(this.state.idea._id, this.state.idea)
                } else {
                    this.props.createIdea(this.state.idea)
                }
            },
        })
    }

    onAddAttachment = (attachment) => {
        this.setState((prevState) => ({
            idea: {
                ...prevState.idea,
                attachments: [...prevState.idea.attachments, attachment],
            },
        }))
    }

    onRemoveAttachment = (attachment) => {
        this.setState((prevState) => ({
            idea: {
                ...prevState.idea,
                attachments: prevState.attachments.filter(
                    (att) => att.name !== attachment.name
                ),
            },
        }))
    }

    render() {
        return (
            <>
                <p className="font-weight-bold text-secondary mt-2">
                    What's your idea?
                </p>

                <TextAreaCharCount
                    placeholder="Give your idea a succint but descriptive title..."
                    onChange={this.onTitleChange}
                    text={this.state.idea.title}
                    maxLength={120}
                    rows={1}
                />

                <div className="mt-2" />

                <TextAreaCharCount
                    placeholder="Describe your idea..."
                    onChange={this.onDescriptionChange}
                    text={this.state.idea.description}
                    maxLength={4000}
                    rows={10}
                />

                <p className="font-weight-bold text-secondary mt-3">
                    Feel free to include any documents that may help explain
                    your idea.
                </p>

                <AttachmentSection
                    onAddAttachment={this.onAddAttachment}
                    onRemoveAttachment={this.onRemoveAttachment}
                    attachments={this.state.idea.attachments}
                    editMode={true}
                />

                <p className="font-weight-bold text-secondary mt-3">
                    Make your idea stand out by choosing an icon and the most
                    relevant tags.
                </p>

                <div className="row px-2">
                    <div className="mb-2 col-sm-12 col-lg-6">
                        <p>
                            <small className="font-weight-bold text-secondary">
                                Icon
                            </small>
                        </p>
                        <IconSelector
                            onSelectionChange={this.onIconSelect}
                            selectedIcon={this.state.idea.icon}
                        />
                    </div>

                    <div className="mb-2 col-sm-12 col-lg-6">
                        <p>
                            <small className="font-weight-bold text-secondary">
                                Tags
                            </small>
                        </p>

                        <TagSelector
                            onSelectionChange={this.onTagSelect}
                            selectedTags={this.state.idea.tags}
                            limit={3}
                        />
                    </div>
                </div>

                <div className="mt-4">
                    <IconButtonLabel
                        onClick={this.onSubmit}
                        text="Submit"
                        icon="paper-plane"
                    />
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    selectedIdeaId: state.ideas.selectedIdeaId,
    idea: state.ideas.idea,
    justSubmitted: state.ideas.justSubmitted,
})

export default withRouter(
    connect(mapStateToProps, {
        getIdea,
        updateIdea,
        createIdea,
        deleteIdea,
    })(SubmitIdeaView)
)
